import { render, staticRenderFns } from "./LoadingPlaces.vue?vue&type=template&id=8b880194"
import script from "./LoadingPlaces.vue?vue&type=script&lang=js"
export * from "./LoadingPlaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports